import React from "react";

const Amount = ({ Item, handleResponse, FormInfo, setInfo }) => {
  return (
    <div className="form-group">
      <label className="my-1 text-capitalize" htmlFor={`#${Item.id}`}>
        {Item.labelName}
      </label>
      {FormInfo.paymentType === "fixed" ? (
        <input
          name={Item.column_name}
          onChange={(e) => handleResponse(e)}
          type="number"
          className="form-control mb-2 form-control_1"
          id={Item.id}
          disabled={true}
          required={Item.isRequired == "1" ? true : false}
          placeholder={`Enter ${Item.labelName}`}
          value={FormInfo.fixedAmount}
        />
      ) : (
        <input
          name={Item.column_name}
          onChange={(e) =>
            setInfo({ ...FormInfo, fixedAmount: e.target.value })
          }
          type="number"
          className="form-control mb-2 form-control_1"
          id={Item.id}
          required={Item.isRequired == "1" ? true : false}
          placeholder={`Enter ${Item.labelName}`}
        />
      )}
    </div>
  );
};

export default Amount;
